import { Response as ClientResponse } from '@finch-api/common/dist/internal/connect/validate';
import { ProviderConfig } from '@finch-api/common/dist/internal/connect/validate';
import styled from 'styled-components';
import InstructionItem from 'components/Instruction/InstructionItem';
import InstructionBox from 'components/Instruction/InstructionBox';
import InstructionItemsBox from 'components/Instruction/InstructionItemsBox';
import { AccountIcon } from 'components/Icons/AccountIcon';
import { EncryptedIcon } from 'components/Icons/EncryptedIcon';
import COLORS from 'constants/colors';
import { useEffect } from 'react';
import { usePopOutInstructionsLink } from 'store/pop-out-instructions';

interface WelcomeProps {
  client: ClientResponse;
  provider: ProviderConfig;
}

const InstructionText = styled.p`
  color: ${COLORS.FINCH.BLACK};
  font-family: Inter;
  font-size: 14px;
  font-style: Medium;
  font-weight: 600;
  line-height: 150%;
  vertical-align: middle;
`;

const Welcome = ({ provider }: WelcomeProps) => {
  const { setPopOutInstructionsLink } = usePopOutInstructionsLink();

  // Clear popout instructions when welcome page loads
  useEffect(() => {
    setPopOutInstructionsLink(null, null);
  }, [setPopOutInstructionsLink]);

  return (
    <InstructionBox>
      <InstructionText>
        To create your connection, you will complete two steps in{' '}
        {provider.displayName}:
      </InstructionText>
      <InstructionItemsBox>
        <InstructionItem
          icon={<AccountIcon />}
          badgeColor={COLORS.GRAY.GRAY_600}
        >
          Create a Service Account and assign it the necessary permissions
        </InstructionItem>
        <InstructionItem
          icon={<EncryptedIcon />}
          badgeColor={COLORS.GRAY.GRAY_600}
        >
          Retrieve your API and web service details
        </InstructionItem>
        <InstructionText style={{ fontWeight: 400 }}>
          These details are stored in different areas of {provider.displayName}.
          Finch will collect them across two screens to make setup easier.
        </InstructionText>
      </InstructionItemsBox>
    </InstructionBox>
  );
};

export default Welcome;
